import { useState, useCallback } from 'react';
/**
 * bool値変更のカスタムhooks
 * @param init_state 初期値
 * @returns
 */
export var useToggle = function (init_state) {
    var _a = useState(init_state), state = _a[0], setState = _a[1];
    var toggle = useCallback(function () {
        setState(function (prev) { return !prev; });
    }, [setState]);
    return [state, toggle];
};
